import LocalStorageUtils from "@/utils/localStorageUtils";

export const TRAVEL_PLANS_FIELD_NAMES = ["dateTrip", "dateReturn", "countriesVisited"] as const;

export const parseStoredRecord = (key: string): Record<string, unknown> => {
  const stored = LocalStorageUtils.getItem(key);

  if (!stored) return {};
  if (typeof stored === "string") {
    try {
      return JSON.parse(stored);
    } catch {
      return {};
    }
  }

  return stored as Record<string, unknown>;
};
